export default __webpack_public_path__ + "assets/Permit.782813ff.svg";